var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-icon",
    transform: "translate(-1 -28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(1 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    d: "M33,0A33,33,0,1,1,0,33,33,33,0,0,1,33,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(13.005 35.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M38.022,29.19l-1.939-1.939-9.994,9.994V4.923H23.35V37.245l-10-10-1.941,1.941,13.3,13.3Z",
    transform: "translate(-4.187 -4.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    x2: 40.633,
    transform: "translate(0 43.116)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMediaIcon);
export default __webpack_public_path__ + "static/media/download_media_icon.655854300d49fc7a8ecf3671748aefe5.svg";
export { ForwardRef as ReactComponent };